var _style, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkill6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 95.7 95.7",
    style: {
      enableBackground: "new 0 0 95.7 95.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);enable-background:new    ;}\n\t.st1{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.4072,
    y1: 47.8587,
    x2: 94.3103,
    y2: 47.8587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8671E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9685F7"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.8,85.2L10.5,69.9c-12.2-12.2-12.2-31.9,0-44l15.3-15.3c12.2-12.2,31.9-12.2,44,0l15.3,15.3 c12.2,12.2,12.2,31.9,0,44L69.9,85.2C57.7,97.4,38,97.4,25.8,85.2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.8,66.1c-0.2,0-0.3,0-0.6-0.2C46.3,65.7,23.9,56,27.8,40c1.5-5.9,7-10.5,12.6-10.5c2.9,0,5.5,1.1,7.4,3 c2-2,4.7-3,7.4-3c5.6,0,11.1,4.6,12.6,10.5C72,56,49.4,65.7,48.4,66C48.3,66.1,48,66.1,47.8,66.1z M40.4,32.5 c-4.2,0-8.5,3.6-9.7,8.3c-3.2,12.3,13.8,20.8,17.1,22.3c3.3-1.5,20.3-10,17.3-22.3l0,0c-1.1-4.6-5.5-8.2-9.7-8.2 c-2.4,0-4.9,1.2-6.4,3.2c-0.3,0.3-0.8,0.6-1.2,0.6l0,0c-0.5,0-0.9-0.2-1.2-0.6C45.3,33.7,42.8,32.5,40.4,32.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkill6);
export default __webpack_public_path__ + "static/media/skill_6.bfa18ab5800cca710419886afa4d28be.svg";
export { ForwardRef as ReactComponent };